import React from "react";
import { withTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import File from "../../components/File/File";
import { HashLink } from "react-router-hash-link";
import "./MaterialyInwestorskie.sass";

class MaterialyInwestorskie extends React.Component {
  componentDidMount() {
    document.title = "Materiały Inwestorskie — BluHolding";
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Header />
        <div className="Home MaterialyInwestorskie">
          <h1 className="Subpage__title">{t("materialsPageTitle")}</h1>

          <section className="section">
            <div className="section__block section__block--white text-center">
              <p>{t("materialsIntro")}</p>
            </div>
          </section>

          <section className="section--gray">
            <div className="w100 flex justify-center">
              <h2>{t("documents")}</h2>
            </div>
            <div className="grid--2-1">
              <File
                active={true}
                fileLink="/static/pdf/Odpis_Pełny_KRS_0001018668.pdf"
                fileName={t("docKRS")}
              />
              <File
                active={true}
                fileLink="/static/pdf/PolitykaPrywatności.pdf"
                fileName={t("docPrivacyPolicy")}
              />
              <File
                active={true}
                fileLink="/static/pdf/BGS  patent zaświadczenie.pdf"
                fileName={t("docPatent")}
              />
            </div>
          </section>

          <section className="section">
            <div className="Subpage__cta">
              <p>{t("materialsOnRequest")}</p>
              <div className="Subpage__cta__buttons">
                <HashLink to="/#kontakt-formularz" className="button--primary">
                  {t("materialsCtaContact")}
                </HashLink>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(MaterialyInwestorskie);
